import IMultiSelectItem from "@/interfaces/selects/IMultiSelectItem";

function valueFromStrToObject(field: string, sourceData: any, relation: IMultiSelectItem[]) {
    if (Array.isArray(sourceData)) {
        sourceData.forEach((item: any) => {
            const ids = item[field];
            if (typeof ids[0] === 'string') {
                item[field] = relation.filter((el: any) => ids.includes(el.value));
            }
        });
    } else {
        Object.entries(sourceData).forEach((item: any) => {
            const key = item[0];
            const value = item[1];

            if (key === field) {
                if (typeof value[0] === 'string') {
                    sourceData[field] = relation.filter((el: any) => value.includes(el.value));
                }
            }
        });
    }
}

export default valueFromStrToObject;